import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Compass = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.275 30 2 23.725 2 16C2 8.275 8.275 2 16 2C23.725 2 30 8.275 30 16C30 23.725 23.725 30 16 30ZM16 4C9.387 4 4 9.387 4 16C4 22.613 9.387 28 16 28C22.613 28 28 22.613 28 16C28 9.387 22.613 4 16 4Z" />
		<path d="M11 22C10.45 22 10 21.55 10 21C10 14.937 14.938 10 21 10C21.55 10 22 10.45 22 11C22 17.063 17.062 22 11 22ZM19.938 12.063C15.825 12.551 12.551 15.825 12.063 19.938C16.176 19.45 19.45 16.176 19.938 12.063V12.063Z" />
	</svg>
);

export default Compass;
